import { fromLocalInput } from '@/lib/format';
import { useAvailabilityCheck } from '@/lib/queries';

function isoOf(local: string): string | null {
  if (!local || local.length < 16) return null;
  try {
    const iso = fromLocalInput(local);
    return Number.isNaN(Date.parse(iso)) ? null : iso;
  } catch {
    return null;
  }
}

/** Debajo de la fecha de una cita: avisa si la sala está cerrada, el asesor no atiende o ya tiene una cita a esa hora. */
export function AvailabilityHint({
  companyId,
  projectId,
  advisorId,
  advisorLabel = 'el asesor',
  at,
  excludeInteractionId,
}: {
  companyId: string;
  projectId?: string | null;
  /** Quien atiende la cita: el asesor de sala si se eligió uno, si no el del lead. */
  advisorId?: string | null;
  /** Cómo nombrar a esa persona en el aviso («el asesor» / «el asesor de sala»). */
  advisorLabel?: string;
  /** Valor del input datetime-local. */
  at: string;
  excludeInteractionId?: string;
}) {
  const iso = isoOf(at);
  const { data } = useAvailabilityCheck(
    iso
      ? {
          companyId,
          projectId: projectId ?? undefined,
          advisorId: advisorId ?? undefined,
          at: iso,
          excludeInteractionId,
        }
      : null,
  );
  if (!iso || !data) return null;
  if (data.available)
    return (
      <p className="text-success text-xs" data-testid="availability-hint">
        Disponible: la sala está abierta{advisorId ? ` y ${advisorLabel} está libre` : ''}.
      </p>
    );
  return (
    <ul className="text-warning list-disc pl-4 text-xs" data-testid="availability-hint">
      {data.issues.map((i) => (
        <li key={i}>{i}</li>
      ))}
    </ul>
  );
}
